<app-permit-common-details [permit]="permit"></app-permit-common-details>

@if (permit.media) {
    <h3 class="h6 mt-3">Project</h3>
    <dl class="row mb-0">
        <dt class="col-sm-4">Organisation</dt>
        <dd class="col-sm-8">{{ permit.media.organisation || '-' }}</dd>

        @if (permit.media.organisationAbn) {
            <dt class="col-sm-4">ABN</dt>
            <dd class="col-sm-8">{{ permit.media.organisationAbn }}</dd>
        }
        @if (permit.media.organisationPhone) {
            <dt class="col-sm-4">Business phone</dt>
            <dd class="col-sm-8">{{ permit.media.organisationPhone }}</dd>
        }
        @if (permit.media.organisationAddress) {
            <dt class="col-sm-4">Business address</dt>
            <dd class="col-sm-8" style="white-space: pre-wrap">{{ permit.media.organisationAddress }}</dd>
        }
        @if (permit.media.organisationWebsite) {
            <dt class="col-sm-4">Website</dt>
            <dd class="col-sm-8"><a [href]="permit.media.organisationWebsite" target="_blank" rel="noopener">{{ permit.media.organisationWebsite }}</a></dd>
        }
        @if (permit.media.medium) {
            <dt class="col-sm-4">Medium</dt>
            <dd class="col-sm-8">{{ permit.media.medium }}</dd>
        }
        @if (permit.media.mediaType) {
            <dt class="col-sm-4">Type</dt>
            <dd class="col-sm-8">{{ permit.media.mediaType }}</dd>
        }
        @if (permit.media.distribution) {
            <dt class="col-sm-4">Distribution</dt>
            <dd class="col-sm-8">{{ permit.media.distribution }}</dd>
        }
        @if (permit.media.usesDrone) {
            <dt class="col-sm-4">Drone / RPA use</dt>
            <dd class="col-sm-8">
                {{ permit.media.usesDrone }}
                @if (permit.media.usesDrone === 'Yes' && permit.media.agreedCasaRules) {
                    <span class="badge text-bg-light border ms-1">CASA rules agreed</span>
                }
            </dd>
        }
        @if (permit.media.usesDrone === 'Yes' && permit.media.droneDetails) {
            <dt class="col-sm-4">Drone details</dt>
            <dd class="col-sm-8" style="white-space: pre-wrap">{{ permit.media.droneDetails }}</dd>
        }
        @if (permit.media.agreedTiwiMaterials) {
            <dt class="col-sm-4">Tiwi materials</dt>
            <dd class="col-sm-8">Agreed to make materials available to TLC on request</dd>
        }
    </dl>
}
